import React, { useState } from 'react';
import { motion } from 'framer-motion';
import PaperCard from './PaperCard';

const ITEMS_PER_PAGE = 18;
const MAX_VISIBLE_PAGES = 7;

function PaperCollection({ papers }) {
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentPapers = papers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(papers.length / ITEMS_PER_PAGE);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPageNumbers = () => {
    let pageNumbers = [];
    let startPage, endPage;

    if (totalPages <= MAX_VISIBLE_PAGES) {
      startPage = 1;
      endPage = totalPages;
    } else {
      const middlePage = Math.floor(MAX_VISIBLE_PAGES / 2);
      if (currentPage <= middlePage) {
        startPage = 1;
        endPage = MAX_VISIBLE_PAGES;
      } else if (currentPage + middlePage >= totalPages) {
        startPage = totalPages - MAX_VISIBLE_PAGES + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - middlePage;
        endPage = currentPage + middlePage;
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={`page-${i}`}
          onClick={() => handlePageChange(i)}
          className={`w-8 h-8 rounded-md text-xs font-bold tabular-nums transition-all duration-200 ${
            currentPage === i
              ? 'bg-yellow-300 text-gray-900 shadow-glow-yellow'
              : 'text-white/40 hover:text-white hover:bg-white/10'
          }`}
        >
          {i}
        </button>
      );
    }
    return pageNumbers;
  };

  if (papers.length === 0) {
    return (
      <div className="glass-card rounded-xl p-16 text-center">
        <div className="text-white/20 text-4xl mb-3 font-bold">[ ]</div>
        <p className="text-white/40 text-sm">No papers found.</p>
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {currentPapers.map((paper, index) => (
          <motion.div
            key={paper.id}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.03, duration: 0.3 }}
          >
            <PaperCard paper={paper} />
          </motion.div>
        ))}
      </div>
      {totalPages > 1 && (
        <div className="flex justify-center items-center gap-1 mt-10">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-2.5 h-8 rounded-md text-xs font-semibold text-white/40 hover:text-white hover:bg-white/10 transition-all duration-200 disabled:opacity-20 disabled:pointer-events-none"
          >
            &lt;
          </button>
          {renderPageNumbers()}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-2.5 h-8 rounded-md text-xs font-semibold text-white/40 hover:text-white hover:bg-white/10 transition-all duration-200 disabled:opacity-20 disabled:pointer-events-none"
          >
            &gt;
          </button>
        </div>
      )}
    </>
  );
}

export default PaperCollection;
